// Auto-generated by scripts/generate-build-info.mjs. Do not edit.
export const buildInfo = {
    commit: '832cd76',
    builtAt: '2026-10-05T11:55:47.401Z',
} as const;
